import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const ResultsValidation: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to validation page since results validation is handled there
    navigate('/samples/validation', { replace: true });
  }, [navigate]);

  return (
    <Box 
      display="flex" 
      flexDirection="column"
      justifyContent="center" 
      alignItems="center" 
      minHeight="400px"
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2, color: 'text.secondary' }}>
        Redirection vers la page de validation...
      </Typography>
    </Box>
  );
};

export default ResultsValidation; 